import {observer} from 'mobx-react';
import {ContextMenu} from "@vidazoo/ui-kit";
import MemoryClipboard from "../../../../common/utils/MemoryClipboard";
import {ReportingContextMenuType} from "../../common/enums/ReportingContextMenuType";
import ReportingSubDimension from "./ReportingSubDimension";
import {ISubGroup} from "../../common/interfaces/ISubGroup";

export interface IReportingSubDimensionsProps {
    subGroups?: ISubGroup[];
    onChangeSubGroup?: (subGroup: ISubGroup, key: string, value: any) => void;
    onDeleteSubGroup?: (subGroup: ISubGroup) => void;
    onAddSubGroupValue?: (subGroup: ISubGroup, value: string, label: string) => void;
    onRemoveSubGroupValue?: (subGroup: ISubGroup, value: string) => void;
    onAddTargetingType?: (subGroup: ISubGroup, value: string, label: string) => void;
    onDeleteTargetingType?: (subGroup: ISubGroup, value: string) => void;
    onAddTargetingOperator: (subGroup: ISubGroup, value: string, label: string) => void;
    onDeleteTargetingOperator: (subGroup: ISubGroup, value: string) => void;
    onClearAllParams: (key: ReportingContextMenuType) => void;
    onPasteSubGroupValues?: (subGroup: ISubGroup) => void;
}

function ReportingSubDimensions(props: IReportingSubDimensionsProps) {
    const {
        onClearAllParams,
        subGroups,
        onChangeSubGroup,
        onDeleteSubGroup,
        onRemoveSubGroupValue,
        onAddSubGroupValue,
        onAddTargetingType,
        onDeleteTargetingType,
        onAddTargetingOperator,
        onDeleteTargetingOperator,
        onPasteSubGroupValues
    } = props;

    // Built per row on every render, like the filters' menus, so Copy reads the row's current values.
    const getContextMenuItems = (subGroup: ISubGroup) => {
        const contextMenuItems = [
            {label: "Clear All Sub Dimensions", onClick: () => onClearAllParams(ReportingContextMenuType.subGroups)},
        ];

        if (subGroup.entities.length) {
            contextMenuItems.push({label: "Copy", onClick: () => MemoryClipboard.copy(subGroup.entities.join(", "))});
        }

        if (subGroup.group && onPasteSubGroupValues) {
            contextMenuItems.push({label: "Paste Multiple", onClick: () => onPasteSubGroupValues(subGroup)});
        }

        return contextMenuItems;
    };

    return (
        <div>
            {subGroups.map((subGroup, idx) => (
                <ContextMenu items={getContextMenuItems(subGroup)} key={subGroup.id || idx}>
                    <div>
                        <ReportingSubDimension
                            index={idx}
                            subGroup={subGroup}
                            onChange={onChangeSubGroup}
                            onDelete={onDeleteSubGroup}
                            onAddValue={onAddSubGroupValue}
                            onAddTargetingType={onAddTargetingType}
                            onDeleteTargetingType={onDeleteTargetingType}
                            onAddTargetingOperator={onAddTargetingOperator}
                            onDeleteTargetingOperator={onDeleteTargetingOperator}
                            onDeleteValue={onRemoveSubGroupValue}/>
                    </div>
                </ContextMenu>
            ))}
        </div>
    )
}

export default observer(ReportingSubDimensions);
